__turbopack_context__.v({
  "application-link": "-D_RrG_application-link",
  "avatar": "-D_RrG_avatar",
  "banner": "-D_RrG_banner",
  "banner-image": "-D_RrG_banner-image",
  "dates": "-D_RrG_dates",
  "dates-header": "-D_RrG_dates-header",
  "dates-list": "-D_RrG_dates-list",
  "deadline-card": "-D_RrG_deadline-card",
  "fancy-card": "-D_RrG_fancy-card",
  "faq": "-D_RrG_faq",
  "faq-image": "-D_RrG_faq-image",
  "faq-nav-item": "-D_RrG_faq-nav-item",
  "faq-nav-link": "-D_RrG_faq-nav-link",
  "faq-title": "-D_RrG_faq-title",
  "features": "-D_RrG_features",
  "hero": "-D_RrG_hero",
  "hero-copy": "-D_RrG_hero-copy",
  "list": "-D_RrG_list",
  "overview-card": "-D_RrG_overview-card",
  "overview-eyebrow": "-D_RrG_overview-eyebrow",
  "overview-icon": "-D_RrG_overview-icon",
  "person": "-D_RrG_person",
  "person-detail": "-D_RrG_person-detail",
  "person-info": "-D_RrG_person-info",
  "person-name": "-D_RrG_person-name",
  "professors-link": "-D_RrG_professors-link",
  "scroll-button": "-D_RrG_scroll-button",
  "section": "-D_RrG_section",
  "step": "-D_RrG_step",
  "step-icon": "-D_RrG_step-icon",
  "step-name": "-D_RrG_step-name",
  "step-subtitle": "-D_RrG_step-subtitle",
  "step-title": "-D_RrG_step-title",
  "testimonial": "-D_RrG_testimonial",
  "university-mark": "-D_RrG_university-mark",
});
